export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostHeader.vue?vue&type=template&id=d7f5f9b8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostHeader.vue?vue&type=template&id=d7f5f9b8&scoped=true
// module id = 305
// module chunks = 0